const error = {
  entryLockedByClaim: 'EntryLockedByClaim',
  entryLimitExceeded: 'EntryLimitExceeded',
  entryKeyOwnedByDifferentPerson: 'EntryKeyOwnedByDifferentPerson',
  entryKeyInCustodyOfDifferentParticipant: 'EntryKeyInCustodyOfDifferentParticipant',
  entryAlreadyExists: 'EntryAlreadyExists'
};

module.exports = error;
